import { render, staticRenderFns } from "./ApproveManage.vue?vue&type=template&id=76aec4c2"
import script from "./ApproveManage.vue?vue&type=script&lang=js"
export * from "./ApproveManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports